module.exports = __webpack_public_path__ + "assets/img/user-ban-dark.ce0f23d5.svg";